{
    "SecureMyOffer.section.propertyInformation": "Property Information",
    "SecureMyOffer.section.residentialMarketValuation": "Residential Market Valuation",
    "SecureMyOffer.section.requestedCoverage": "Requested Coverage",
    "SecureMyOffer.section.preApprovalInformation": "Pre-Approval Information",
    "SecureMyOffer.section.insuranceQuestions": "Insurance Questions",
    "SecureMyOffer.section.notListedInformation": "Not Listed Information",

    "SecureMyOffer.field.isRuralArea": "Property is in Rural Area",
    "SecureMyOffer.field.saleStatus": "What is the status of your property?",
    "SecureMyOffer.field.expectedListingDate": "When do you expect to list the house?",
    "SecureMyOffer.field.intendedSalePrice": "What is the intended sale price?",
    "SecureMyOffer.field.saleChannel": "How do you intend to sell your property?",
    "SecureMyOffer.field.realtorChosen": "Have you chosen a Realtor yet?",
    "SecureMyOffer.field.isSeller": "Are you the seller?",
    "SecureMyOffer.field.conditionalPeriodExpiry": "When does the conditional period expire?",
    "SecureMyOffer.field.conditionalClosingDate": "When is the conditional closing date?",

    "SecureMyOffer.field.hasFirmOffer": "Do you have a firm offer?",
    "SecureMyOffer.field.hasSecuredDeposit": "Is your real estate agent or lawyer holding a deposit in trust?",
    "SecureMyOffer.field.securedDepositAmount": "How much is the deposit?",
    "SecureMyOffer.field.currentClosingDate": "What is the closing date?",
    "SecureMyOffer.field.saleAmount": "What is the sale price?",

    "SecureMyOffer.field.residentialMarketValuationConfidenceRating": "Confidence Rating",
    "SecureMyOffer.field.lowestValuationRange": "Lowest Valuation Range",
    "SecureMyOffer.field.highestValuationRange": "Highest Valuation Range",
    "SecureMyOffer.field.actualValuation": "Actual Valuation",
    "SecureMyOffer.field.valuationDate": "Date of Valuation",

    "SecureMyOffer.field.coverageCodeSelected": "Selected Coverage",
    "SecureMyOffer.field.isBnplProgram": "Buy Now Pay Later",
    "SecureMyOffer.field.hasNewHomePurchased": "Has a new home been already purchased?",
    "SecureMyOffer.field.newHomePurchasedClosingDate": "What is the closing date of the new home purchased?",
    "SecureMyOffer.field.isResidentialSingleUnit": "Is Single-Unit Residential Home?",

    "SecureMyOffer.field.isPrimaryResidence": "Is this a residential property and being used as the Seller's Primary Residence?",
    "SecureMyOffer.field.saleAmountConfirm": "Please confirm the agreed upon sale price",
    "SecureMyOffer.field.isCondo": "Is this property a condo or part of a condominium?",
    "SecureMyOffer.field.currentPropertySaleGoFirmDate": "On what day did the offer \"go firm\"?",
    "SecureMyOffer.field.depositAmount": "What is the value of the buyer's cash deposit being held in trust?",
    "SecureMyOffer.field.currentPropertySaleClosingDate": "What is the closing date of the purchase and sale agreement?",
    "SecureMyOffer.field.usedRealEstateAgent": "Were the Seller and Buyer each represented by a Licensed Real Estate Agent?",
    "SecureMyOffer.field.isRelatedToBuyer": "Do the Buyer and Seller have any previous relationship?",
    "SecureMyOffer.field.buyerSellerRelationship": "Describe the previous relationship",
    "SecureMyOffer.field.uncertainBuyer": "Is there any reason to suspect that the buyer will not proceed with the purchase?",

    "SecureMyOffer.button.getValuation": "Get Valuation",
    "SecureMyOffer.section.homeValueEstimate": "Home Value Estimate",
    "SecureMyOffer.button.getEstimatedHomeValue": "Get Estimated Home Value",

    "SecureMyOffer.field.lowestValuationRangeOverride": "Lowest Valuation Range Override",
    "SecureMyOffer.field.highestValuationRangeOverride": "Highest Valuation Range Override",
    "SecureMyOffer.field.actualValuationOverride": "Actual Valuation Override"
}
